import type { SVGProps } from "react";

export function LockIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect width="48" height="48" rx="4" fill="#BCDCFB" />
      <path
        d="M18 16C18 12.6863 20.6863 10 24 10C27.3137 10 30 12.6863 30 16V17H31.5C33.9853 17 36 19.0147 36 21.5V33.5C36 35.9853 33.9853 38 31.5 38H16.5C14.0147 38 12 35.9853 12 33.5V21.5C12 19.0147 14.0147 17 16.5 17H18V16ZM24 12C21.7909 12 20 13.7909 20 16V17H28V16C28 13.7909 26.2091 12 24 12ZM24 30C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26C22.8954 26 22 26.8954 22 28C22 29.1046 22.8954 30 24 30Z"
        fill="#0F3C6B"
      />
    </svg>
  );
}
